var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#ED79AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.589 6.69675L16.1865 8.109C15.6812 7.59794 15.0794 7.19231 14.4161 6.91563C13.7528 6.63896 13.0412 6.49675 12.3225 6.49725C9.38627 6.49725 6.99002 8.82975 6.86402 11.7548H6.85801V17.0963C5.57939 15.7075 4.87131 13.8877 4.87501 12C4.87501 7.85775 8.20951 4.5 12.3225 4.5C13.3021 4.49931 14.272 4.69313 15.1761 5.07023C16.0801 5.44733 16.9003 6.00019 17.589 6.69675ZM17.589 17.3033C16.2276 18.6806 14.3804 19.4693 12.444 19.5V17.502C13.8533 17.4715 15.1954 16.894 16.1865 15.8918L17.589 17.3033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76074 18.588V11.7555H8.76599C8.87099 9.80175 10.4775 8.25 12.444 8.25C14.478 8.25 16.1272 9.9105 16.1272 11.9595C16.1272 14.0078 14.478 15.6683 12.4447 15.6683C11.7897 15.6693 11.1464 15.494 10.5825 15.1605V19.2938C9.94664 19.1407 9.334 18.9036 8.76074 18.5888V18.588ZM12.444 13.8345C12.6894 13.8337 12.9322 13.7846 13.1587 13.6899C13.3851 13.5953 13.5906 13.4569 13.7636 13.2828C13.9365 13.1087 14.0734 12.9022 14.1665 12.6751C14.2597 12.4481 14.3071 12.2049 14.3062 11.9595C14.3062 10.9238 13.4722 10.0845 12.444 10.0845C12.1986 10.0854 11.9559 10.1346 11.7296 10.2293C11.5032 10.324 11.2978 10.4624 11.1249 10.6365C10.9521 10.8106 10.8152 11.017 10.7221 11.244C10.629 11.471 10.5816 11.7142 10.5825 11.9595C10.5825 12.9945 11.4157 13.8345 12.444 13.8345Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.9470d98ac6be5cf6a1adf7aeecc927a9.svg";
export { ForwardRef as ReactComponent };